module.exports = __webpack_public_path__ + "img/logo.2fdebcce.svg";